import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

const MainLayout = () => {
  return (
    <>
    <Navbar/>
     <Footer/>
     <Outlet/>
    </>
  )
}

export default MainLayout